import { ERROR, HIDE_ERROR, COMMON_START_LOADER, COMMON_STOP_LOADER, ADD_MSG, CLEAR_MSG, UPDATE_TIME, } from "../../interface/iCommon";
const initState = {
    loader: true,
    message: {
        msg: null,
        show: false,
        icon: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    updateTime: "",
};
const commonReducer = (state = initState, action) => {
    switch (action.type) {
        case ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case COMMON_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case COMMON_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        case ADD_MSG:
            return Object.assign(Object.assign({}, state), { message: action.payload.message });
        case CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { message: initState.message });
        case UPDATE_TIME:
            return Object.assign(Object.assign({}, state), { updateTime: action.payload.updatedTime });
        default:
            return Object.assign({}, state);
    }
};
export default commonReducer;
